class SettingsInstance {
  constructor() {
    if (!SettingsInstance.instance) {
      SettingsInstance.instance = this;
    }

    if (process.env.UKETST) {
      this.baseUrl = 'https://testpitmap.uke.gov.pl';
      this.baseApiUrl = 'https://testpitmap.uke.gov.pl/api/v1';
      this.baseApiNewUrl = 'https://testpitmap.uke.gov.pl/api/v1/proxyapi';
      this.baseApiAuth = 'https://testpitmap.uke.gov.pl/pit2/auth';
      this.geoserverUrl = 'https://testpitmap.uke.gov.pl/api/v1/geoserver';
      this.searchApiUrl = 'https://devpitmap.softcream.pl/search';
      this.geocodingApiUrl =
        'https://pit.inprojects.local/pit2/geocodedata';
      this.sessionTimeout = '300';
    } else if (process.env.UKEPROD) {
      this.baseUrl = 'https://pitmap.uke.gov.pl';
      this.baseApiUrl = 'https://pitmap.uke.gov.pl/api/v1';
      this.baseApiNewUrl = 'https://pitmap.uke.gov.pl/api/v1/proxyapi';
      this.baseApiAuth = 'https://pitmap.uke.gov.pl/pit2/auth';
      this.geoserverUrl = 'https://pitmap.uke.gov.pl/api/v1/geoserver';
      this.searchApiUrl = 'https://devpitmap.softcream.pl/search';
      this.geocodingApiUrl =
        'https://pit.inprojects.local/pit2/geocodedata';
      this.sessionTimeout = '300';
    } else if (process.env.DEMO) {
      this.baseUrl = '${PITMAP_BASE_URL}';
      this.baseApiUrl = '${PITMAP_BASE_API_URL}';
      this.baseApiNewUrl = '${PITMAP_BASE_API_NEW_URL}';
      this.baseApiAuth = '${PITMAP_BASE_API_AUTH_URL}';
      this.geoserverUrl = '${PITMAP_GEOSERVER_URL}';
      this.mapdataUrl = '${PITMAP_MAPDATA_URL}';
      this.searchApiUrl = '${SEARCH_API_URL}';
      this.geocodingApiUrl = '${GEOCODING_API_URL}';
      this.sessionTimeout = '${SESSION_TIMEOUT}';
    } else if (process.env.NODE_ENV == 'production') {
      this.baseUrl = 'https://pit-test.evertop.pl';
      this.baseApiUrl = 'https://pit-test.evertop.pl/api/v1';
      this.baseApiNewUrl = 'https://pit-test.evertop.pl/api/v1/proxyapi';
      this.baseApiAuth = 'https://pit-test.evertop.pl/pit2/auth';
      this.geoserverUrl = 'https://pit-test.evertop.pl/api/v1/geoserver';
      this.searchApiUrl = 'https://devpitmap.softcream.pl/search';
      this.geocodingApiUrl =
        'https://pit.inprojects.local/pit2/geocodedata';
      this.sessionTimeout = '300';
    } else {
      this.baseUrl = 'https://pit.inprojects.local';
      this.baseApiUrl = 'https://pit.inprojects.local/api/v1';
      this.baseApiNewUrl =
        'https://pit.inprojects.local/pit2/PitMapa/backend';
      this.baseApiAuth = 'https://pit.inprojects.local/pit2/auth';
      this.geoserverUrl =
        'https://pit.inprojects.local/pit2/PitMapa/backend/geoserver';
      this.mapdataUrl = 'https://pit.inprojects.local/pit2/PitMapa/backend/mapdata/layers/';
      this.searchApiUrl = 'https://pit.inprojects.local/search';
      this.geocodingApiUrl =
        'https://pit.inprojects.local/pit2/geocodedata';
      this.sessionTimeout = '300';
    }
    this.dateTimeFormat = 'DD-MM-YYYY HH:mm';
    this.dateFormat = 'DD-MM-YYYY';
    this.timeFormat = 'HH:mm';
  }
}

const instance = new SettingsInstance();

module.exports = instance;
